module.exports = __webpack_public_path__ + "static/media/dragon-for.d685a7d2.png";